import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ExternalLink } from '../../../common/ExternalLink'
import { positionDropdown } from '../../../common/dropdown'
import { UseI18n } from '../../../common/hooks/useI18n'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { STATUS_COLOR } from '../../../common/statusTag'
import { Tooltip } from '../../../common/tooltip'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { formatText, formatVal, isInValidValue } from '../../../helpers/value'
import { EMPTY_VALUE } from '../../../utils/common'

import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { OVERVIEW_KEYS } from '../constant'
import { selectCompanyInfoDetail } from '../store/slice'
import { languages } from './../../../../configs/language'
import classes from './index.module.scss'

export const InfoItem = ({ dataKey, isDynamicReport }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const { organizationNameAlternate } = useSelector(selectCompanyInfo)
  const data = useSelector(
    selectCompanyInfoDetail((data) => data[OVERVIEW_KEYS[dataKey]]),
  )
  const { activeStatusId } = useSelector(selectCompanyInfo)

  const yearsText = UseI18n('companyProfile.YEARS')
  const yearText = UseI18n('companyProfile.YEAR')

  const renderDataName = () => {
    const name = `companyProfile.${dataKey}`
    switch (OVERVIEW_KEYS[dataKey]) {
      case OVERVIEW_KEYS.NUMBER_OF_EMPLOYEES:
        return (
          <Element className="dFlex gap1">
            <Translate value={name} />
            {!isDynamicReport && (
              <Tooltip
                tooltipContent="companyProfile.NUMBER_OF_EMPLOYEES_TOOLTIP"
                isI18n
                position={positionDropdown.TOP_CENTER}
                tooltipContentStyle={{
                  whiteSpace: 'nowrap',
                  fontWeight: '400',
                }}
              >
                <Icon
                  className="icon-info-circle"
                  style={{ color: '#9C9C9C', fontSize: 13 }}
                />
              </Tooltip>
            )}
          </Element>
        )
      default:
        return <Translate value={name} />
    }
  }

  const renderDataValue = () => {
    if (isInValidValue(data)) return EMPTY_VALUE

    switch (OVERVIEW_KEYS[dataKey]) {
      case OVERVIEW_KEYS.VIETNAMESE_NAME:
        return locale === languages.vi
          ? data
          : organizationNameAlternate || EMPTY_VALUE
      case OVERVIEW_KEYS.ENTERPRISE_STATUS:
        return (
          <Element
            className={classes.enterpriseStatus}
            style={{
              backgroundColor: STATUS_COLOR[activeStatusId],
              color: '#FFFFFF',
            }}
          >
            {data}
          </Element>
        )
      case OVERVIEW_KEYS.LISTING_STATUS:
        return <span className="textCapitalize">{data}</span>
      case OVERVIEW_KEYS.COMPANY_TYPE:
        return <Translate value={`companyProfile.companyType.${data}`} />
      case OVERVIEW_KEYS.DATE_OF_REGISTRATION:
        return formatDateTime(data, FORMAT.DATE, locale, timezone)
      case OVERVIEW_KEYS.YEARS_OF_OPERATION:
        return (
          formatVal(data, locale, false, 0) +
          ' ' +
          (data <= 1 ? yearText : yearsText)
        )
      case OVERVIEW_KEYS.NUMBER_OF_EMPLOYEES:
        return formatVal(data, locale, false, 0)
      case OVERVIEW_KEYS.LEGAL_REPRESENTATIVE:
        return data.fullName || EMPTY_VALUE
      case OVERVIEW_KEYS.WEBSITE:
        return (
          <ExternalLink href={data} isDynamicReport={isDynamicReport}>
            {data}
          </ExternalLink>
        )
      default:
        return formatText(data)
    }
  }

  return (
    <Element className={classes.infoItem}>
      <Element className={classes.infoName}>{renderDataName()}</Element>
      <Element className={classes.infoData}>{renderDataValue()}</Element>
    </Element>
  )
}
